import React, { useEffect, useMemo, useState } from 'react';
import { css } from '@emotion/react';
import { useMutation } from '@apollo/client';
import { useClientUser } from '@/hooks';
import { captureException } from '@sentry/react';
import { TextField } from '@material-ui/core';
import { SecondaryButton, PrimaryButton } from '@/styles/blocks';
import NavResponsiveModal, {
    ModalActions,
    ModalContent,
    ModalHeader,
} from '@/components/Navigation/NavResponsiveModal';
import { UPDATE_CLIENT } from '../Account/CustomTags/graphql';

const AdminNotesModal = ({ handleClose, open }) => {
    const { onward_admin_notes, client_id } = useClientUser();
    const [note, setNote] = useState('');

    const [updateClient, { loading: clientUpdateLoading }] = useMutation(UPDATE_CLIENT, {
        onError: (error) => {
            captureException(error);
            console.error(error);
        },
    });

    const handleNoteSave = async () => {
        await updateClient({
            variables: {
                client_id: client_id,
                update: {
                    onward_admin_notes: note,
                },
            },
        });
        handleClose();
    };

    useEffect(() => {
        setNote(onward_admin_notes || '');
    }, [onward_admin_notes]);

    return (
        <NavResponsiveModal open={open} onClose={handleClose}>
            <ModalHeader title={'Network Admin Notes'} onClose={handleClose} />
            <ModalContent
                css={css`
                    width: 600px;
                `}
            >
                <TextField
                    multiline
                    minRows={10}
                    maxRows={10}
                    fullWidth
                    variant="outlined"
                    type="text"
                    disabled={clientUpdateLoading}
                    value={note || ''}
                    onChange={(e) => {
                        setNote(e.target.value);
                    }}
                />
            </ModalContent>
            <ModalActions>
                <SecondaryButton disabled={clientUpdateLoading} onClick={handleClose}>
                    Cancel
                </SecondaryButton>
                <PrimaryButton disabled={clientUpdateLoading} onClick={() => handleNoteSave()}>
                    Save
                </PrimaryButton>
            </ModalActions>
        </NavResponsiveModal>
    );
};

export default AdminNotesModal;
